/* eslint-disable */
// AUTO-GENERATED by scripts/generate-operations.ts from @up2rent/models. Do not edit by hand.

export const onAuthTeamMutation = /* GraphQL */ `subscription OnAuthTeamMutation($clientId: ID!) {
  onAuthTeamMutation(clientId: $clientId) {
    clientId
    id
    name
    parentId
    __typename
  }
}
`;

export const onAuthUserRoleMutation = /* GraphQL */ `subscription OnAuthUserRoleMutation($clientId: ID!) {
  onAuthUserRoleMutation(clientId: $clientId) {
    clientId
    id
    isDefault
    name
    userRights {
      access
      section
      __typename
    }
    __typename
  }
}
`;

export const onAuthUserTeamMutation = /* GraphQL */ `subscription OnAuthUserTeamMutation($clientId: ID!) {
  onAuthUserTeamMutation(clientId: $clientId) {
    clientId
    dynamoUserId
    id
    teamId
    userId
    __typename
  }
}
`;

export const onCreateAccountLabel = /* GraphQL */ `subscription OnCreateAccountLabel($filter: ModelSubscriptionAccountLabelFilterInput) {
  onCreateAccountLabel(filter: $filter) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateAddress = /* GraphQL */ `subscription OnCreateAddress($filter: ModelSubscriptionAddressFilterInput) {
  onCreateAddress(filter: $filter) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateAdminCommunication = /* GraphQL */ `subscription OnCreateAdminCommunication($filter: ModelSubscriptionAdminCommunicationFilterInput) {
  onCreateAdminCommunication(filter: $filter) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateAdminFile = /* GraphQL */ `subscription OnCreateAdminFile($filter: ModelSubscriptionAdminFileFilterInput) {
  onCreateAdminFile(filter: $filter) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateApplicationInvoice = /* GraphQL */ `subscription OnCreateApplicationInvoice($filter: ModelSubscriptionApplicationInvoiceFilterInput) {
  onCreateApplicationInvoice(filter: $filter) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateApplicationInvoiceLine = /* GraphQL */ `subscription OnCreateApplicationInvoiceLine($filter: ModelSubscriptionApplicationInvoiceLineFilterInput) {
  onCreateApplicationInvoiceLine(filter: $filter) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateApplicationPlan = /* GraphQL */ `subscription OnCreateApplicationPlan($filter: ModelSubscriptionApplicationPlanFilterInput) {
  onCreateApplicationPlan(filter: $filter) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateApplicationSubscription = /* GraphQL */ `subscription OnCreateApplicationSubscription($filter: ModelSubscriptionApplicationSubscriptionFilterInput) {
  onCreateApplicationSubscription(filter: $filter) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateApplicationSubscriptionVariousOperation = /* GraphQL */ `subscription OnCreateApplicationSubscriptionVariousOperation($filter: ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput) {
  onCreateApplicationSubscriptionVariousOperation(filter: $filter) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateApplicationVariousOperation = /* GraphQL */ `subscription OnCreateApplicationVariousOperation($filter: ModelSubscriptionApplicationVariousOperationFilterInput) {
  onCreateApplicationVariousOperation(filter: $filter) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateBankAccount = /* GraphQL */ `subscription OnCreateBankAccount($filter: ModelSubscriptionBankAccountFilterInput) {
  onCreateBankAccount(filter: $filter) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateBillingItem = /* GraphQL */ `subscription OnCreateBillingItem($filter: ModelSubscriptionBillingItemFilterInput) {
  onCreateBillingItem(filter: $filter) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateBuilding = /* GraphQL */ `subscription OnCreateBuilding($filter: ModelSubscriptionBuildingFilterInput) {
  onCreateBuilding(filter: $filter) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateBuildingEvent = /* GraphQL */ `subscription OnCreateBuildingEvent($filter: ModelSubscriptionBuildingEventFilterInput) {
  onCreateBuildingEvent(filter: $filter) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateBuildingOwner = /* GraphQL */ `subscription OnCreateBuildingOwner($filter: ModelSubscriptionBuildingOwnerFilterInput) {
  onCreateBuildingOwner(filter: $filter) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateBuildingSite = /* GraphQL */ `subscription OnCreateBuildingSite($filter: ModelSubscriptionBuildingSiteFilterInput) {
  onCreateBuildingSite(filter: $filter) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCause = /* GraphQL */ `subscription OnCreateCause($filter: ModelSubscriptionCauseFilterInput) {
  onCreateCause(filter: $filter) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCharge = /* GraphQL */ `subscription OnCreateCharge($filter: ModelSubscriptionChargeFilterInput) {
  onCreateCharge(filter: $filter) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateChargeEnvelope = /* GraphQL */ `subscription OnCreateChargeEnvelope($filter: ModelSubscriptionChargeEnvelopeFilterInput) {
  onCreateChargeEnvelope(filter: $filter) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateChargeSection = /* GraphQL */ `subscription OnCreateChargeSection($filter: ModelSubscriptionChargeSectionFilterInput) {
  onCreateChargeSection(filter: $filter) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCommunication = /* GraphQL */ `subscription OnCreateCommunication($filter: ModelSubscriptionCommunicationFilterInput) {
  onCreateCommunication(filter: $filter) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCommunicationSettingsProfile = /* GraphQL */ `subscription OnCreateCommunicationSettingsProfile($filter: ModelSubscriptionCommunicationSettingsProfileFilterInput) {
  onCreateCommunicationSettingsProfile(filter: $filter) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCompanyUser = /* GraphQL */ `subscription OnCreateCompanyUser($filter: ModelSubscriptionCompanyUserFilterInput) {
  onCreateCompanyUser(filter: $filter) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateContact = /* GraphQL */ `subscription OnCreateContact($filter: ModelSubscriptionContactFilterInput) {
  onCreateContact(filter: $filter) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCreditCost = /* GraphQL */ `subscription OnCreateCreditCost($filter: ModelSubscriptionCreditCostFilterInput) {
  onCreateCreditCost(filter: $filter) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCreditUsageCost = /* GraphQL */ `subscription OnCreateCreditUsageCost($filter: ModelSubscriptionCreditUsageCostFilterInput) {
  onCreateCreditUsageCost(filter: $filter) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCustomField = /* GraphQL */ `subscription OnCreateCustomField($filter: ModelSubscriptionCustomFieldFilterInput) {
  onCreateCustomField(filter: $filter) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateCustomSubscription = /* GraphQL */ `subscription OnCreateCustomSubscription($filter: ModelSubscriptionCustomSubscriptionFilterInput) {
  onCreateCustomSubscription(filter: $filter) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateDocumentCategory = /* GraphQL */ `subscription OnCreateDocumentCategory($filter: ModelSubscriptionDocumentCategoryFilterInput) {
  onCreateDocumentCategory(filter: $filter) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateDocumentExtraction = /* GraphQL */ `subscription OnCreateDocumentExtraction($filter: ModelSubscriptionDocumentExtractionFilterInput) {
  onCreateDocumentExtraction(filter: $filter) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateDocumentNumber = /* GraphQL */ `subscription OnCreateDocumentNumber($filter: ModelSubscriptionDocumentNumberFilterInput) {
  onCreateDocumentNumber(filter: $filter) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateEntityAlias = /* GraphQL */ `subscription OnCreateEntityAlias($filter: ModelSubscriptionEntityAliasFilterInput) {
  onCreateEntityAlias(filter: $filter) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateEntityRelation = /* GraphQL */ `subscription OnCreateEntityRelation($filter: ModelSubscriptionEntityRelationFilterInput) {
  onCreateEntityRelation(filter: $filter) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateFeeArrears = /* GraphQL */ `subscription OnCreateFeeArrears($filter: ModelSubscriptionFeeArrearsFilterInput) {
  onCreateFeeArrears(filter: $filter) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateFile = /* GraphQL */ `subscription OnCreateFile($filter: ModelSubscriptionFileFilterInput) {
  onCreateFile(filter: $filter) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateFilterGroup = /* GraphQL */ `subscription OnCreateFilterGroup($filter: ModelSubscriptionFilterGroupFilterInput) {
  onCreateFilterGroup(filter: $filter) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateImportRun = /* GraphQL */ `subscription OnCreateImportRun($filter: ModelSubscriptionImportRunFilterInput) {
  onCreateImportRun(filter: $filter) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateIntegration = /* GraphQL */ `subscription OnCreateIntegration($filter: ModelSubscriptionIntegrationFilterInput) {
  onCreateIntegration(filter: $filter) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateInternalComment = /* GraphQL */ `subscription OnCreateInternalComment($filter: ModelSubscriptionInternalCommentFilterInput) {
  onCreateInternalComment(filter: $filter) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateInvoice = /* GraphQL */ `subscription OnCreateInvoice($filter: ModelSubscriptionInvoiceFilterInput) {
  onCreateInvoice(filter: $filter) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateLearningEvent = /* GraphQL */ `subscription OnCreateLearningEvent($filter: ModelSubscriptionLearningEventFilterInput) {
  onCreateLearningEvent(filter: $filter) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateLease = /* GraphQL */ `subscription OnCreateLease($filter: ModelSubscriptionLeaseFilterInput) {
  onCreateLease(filter: $filter) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateLeaseContact = /* GraphQL */ `subscription OnCreateLeaseContact($filter: ModelSubscriptionLeaseContactFilterInput) {
  onCreateLeaseContact(filter: $filter) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateLeasePriceHistory = /* GraphQL */ `subscription OnCreateLeasePriceHistory($filter: ModelSubscriptionLeasePriceHistoryFilterInput) {
  onCreateLeasePriceHistory(filter: $filter) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateNotification = /* GraphQL */ `subscription OnCreateNotification($filter: ModelSubscriptionNotificationFilterInput) {
  onCreateNotification(filter: $filter) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreatePaymentBatch = /* GraphQL */ `subscription OnCreatePaymentBatch($filter: ModelSubscriptionPaymentBatchFilterInput) {
  onCreatePaymentBatch(filter: $filter) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreatePaymentOrder = /* GraphQL */ `subscription OnCreatePaymentOrder($filter: ModelSubscriptionPaymentOrderFilterInput) {
  onCreatePaymentOrder(filter: $filter) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreatePosting = /* GraphQL */ `subscription OnCreatePosting($filter: ModelSubscriptionPostingFilterInput) {
  onCreatePosting(filter: $filter) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateRecurringPaymentTemplate = /* GraphQL */ `subscription OnCreateRecurringPaymentTemplate($filter: ModelSubscriptionRecurringPaymentTemplateFilterInput) {
  onCreateRecurringPaymentTemplate(filter: $filter) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateScheduleRule = /* GraphQL */ `subscription OnCreateScheduleRule($filter: ModelSubscriptionScheduleRuleFilterInput) {
  onCreateScheduleRule(filter: $filter) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateSenderRule = /* GraphQL */ `subscription OnCreateSenderRule($filter: ModelSubscriptionSenderRuleFilterInput) {
  onCreateSenderRule(filter: $filter) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateSendingSource = /* GraphQL */ `subscription OnCreateSendingSource($filter: ModelSubscriptionSendingSourceFilterInput) {
  onCreateSendingSource(filter: $filter) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateSignatureDocument = /* GraphQL */ `subscription OnCreateSignatureDocument($filter: ModelSubscriptionSignatureDocumentFilterInput) {
  onCreateSignatureDocument(filter: $filter) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateSubscriptionUsageHistory = /* GraphQL */ `subscription OnCreateSubscriptionUsageHistory($filter: ModelSubscriptionSubscriptionUsageHistoryFilterInput) {
  onCreateSubscriptionUsageHistory(filter: $filter) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateTag = /* GraphQL */ `subscription OnCreateTag($filter: ModelSubscriptionTagFilterInput) {
  onCreateTag(filter: $filter) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateTechnic = /* GraphQL */ `subscription OnCreateTechnic($filter: ModelSubscriptionTechnicFilterInput) {
  onCreateTechnic(filter: $filter) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateTechnicLibrary = /* GraphQL */ `subscription OnCreateTechnicLibrary($filter: ModelSubscriptionTechnicLibraryFilterInput) {
  onCreateTechnicLibrary(filter: $filter) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateTicket = /* GraphQL */ `subscription OnCreateTicket($filter: ModelSubscriptionTicketFilterInput) {
  onCreateTicket(filter: $filter) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateTransaction = /* GraphQL */ `subscription OnCreateTransaction($filter: ModelSubscriptionTransactionFilterInput) {
  onCreateTransaction(filter: $filter) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateUnit = /* GraphQL */ `subscription OnCreateUnit($filter: ModelSubscriptionUnitFilterInput) {
  onCreateUnit(filter: $filter) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateUnitEvent = /* GraphQL */ `subscription OnCreateUnitEvent($filter: ModelSubscriptionUnitEventFilterInput) {
  onCreateUnitEvent(filter: $filter) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateUnitInventory = /* GraphQL */ `subscription OnCreateUnitInventory($filter: ModelSubscriptionUnitInventoryFilterInput) {
  onCreateUnitInventory(filter: $filter) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateUnitLease = /* GraphQL */ `subscription OnCreateUnitLease($filter: ModelSubscriptionUnitLeaseFilterInput) {
  onCreateUnitLease(filter: $filter) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onCreateUnitOwner = /* GraphQL */ `subscription OnCreateUnitOwner($filter: ModelSubscriptionUnitOwnerFilterInput) {
  onCreateUnitOwner(filter: $filter) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteAccountLabel = /* GraphQL */ `subscription OnDeleteAccountLabel($filter: ModelSubscriptionAccountLabelFilterInput) {
  onDeleteAccountLabel(filter: $filter) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteAddress = /* GraphQL */ `subscription OnDeleteAddress($filter: ModelSubscriptionAddressFilterInput) {
  onDeleteAddress(filter: $filter) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteAdminCommunication = /* GraphQL */ `subscription OnDeleteAdminCommunication($filter: ModelSubscriptionAdminCommunicationFilterInput) {
  onDeleteAdminCommunication(filter: $filter) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteAdminFile = /* GraphQL */ `subscription OnDeleteAdminFile($filter: ModelSubscriptionAdminFileFilterInput) {
  onDeleteAdminFile(filter: $filter) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteApplicationInvoice = /* GraphQL */ `subscription OnDeleteApplicationInvoice($filter: ModelSubscriptionApplicationInvoiceFilterInput) {
  onDeleteApplicationInvoice(filter: $filter) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteApplicationInvoiceLine = /* GraphQL */ `subscription OnDeleteApplicationInvoiceLine($filter: ModelSubscriptionApplicationInvoiceLineFilterInput) {
  onDeleteApplicationInvoiceLine(filter: $filter) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteApplicationPlan = /* GraphQL */ `subscription OnDeleteApplicationPlan($filter: ModelSubscriptionApplicationPlanFilterInput) {
  onDeleteApplicationPlan(filter: $filter) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteApplicationSubscription = /* GraphQL */ `subscription OnDeleteApplicationSubscription($filter: ModelSubscriptionApplicationSubscriptionFilterInput) {
  onDeleteApplicationSubscription(filter: $filter) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteApplicationSubscriptionVariousOperation = /* GraphQL */ `subscription OnDeleteApplicationSubscriptionVariousOperation($filter: ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput) {
  onDeleteApplicationSubscriptionVariousOperation(filter: $filter) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteApplicationVariousOperation = /* GraphQL */ `subscription OnDeleteApplicationVariousOperation($filter: ModelSubscriptionApplicationVariousOperationFilterInput) {
  onDeleteApplicationVariousOperation(filter: $filter) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteBankAccount = /* GraphQL */ `subscription OnDeleteBankAccount($filter: ModelSubscriptionBankAccountFilterInput) {
  onDeleteBankAccount(filter: $filter) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteBillingItem = /* GraphQL */ `subscription OnDeleteBillingItem($filter: ModelSubscriptionBillingItemFilterInput) {
  onDeleteBillingItem(filter: $filter) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteBuilding = /* GraphQL */ `subscription OnDeleteBuilding($filter: ModelSubscriptionBuildingFilterInput) {
  onDeleteBuilding(filter: $filter) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteBuildingEvent = /* GraphQL */ `subscription OnDeleteBuildingEvent($filter: ModelSubscriptionBuildingEventFilterInput) {
  onDeleteBuildingEvent(filter: $filter) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteBuildingOwner = /* GraphQL */ `subscription OnDeleteBuildingOwner($filter: ModelSubscriptionBuildingOwnerFilterInput) {
  onDeleteBuildingOwner(filter: $filter) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteBuildingSite = /* GraphQL */ `subscription OnDeleteBuildingSite($filter: ModelSubscriptionBuildingSiteFilterInput) {
  onDeleteBuildingSite(filter: $filter) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCause = /* GraphQL */ `subscription OnDeleteCause($filter: ModelSubscriptionCauseFilterInput) {
  onDeleteCause(filter: $filter) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCharge = /* GraphQL */ `subscription OnDeleteCharge($filter: ModelSubscriptionChargeFilterInput) {
  onDeleteCharge(filter: $filter) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteChargeEnvelope = /* GraphQL */ `subscription OnDeleteChargeEnvelope($filter: ModelSubscriptionChargeEnvelopeFilterInput) {
  onDeleteChargeEnvelope(filter: $filter) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteChargeSection = /* GraphQL */ `subscription OnDeleteChargeSection($filter: ModelSubscriptionChargeSectionFilterInput) {
  onDeleteChargeSection(filter: $filter) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCommunication = /* GraphQL */ `subscription OnDeleteCommunication($filter: ModelSubscriptionCommunicationFilterInput) {
  onDeleteCommunication(filter: $filter) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCommunicationSettingsProfile = /* GraphQL */ `subscription OnDeleteCommunicationSettingsProfile($filter: ModelSubscriptionCommunicationSettingsProfileFilterInput) {
  onDeleteCommunicationSettingsProfile(filter: $filter) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCompanyUser = /* GraphQL */ `subscription OnDeleteCompanyUser($filter: ModelSubscriptionCompanyUserFilterInput) {
  onDeleteCompanyUser(filter: $filter) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteContact = /* GraphQL */ `subscription OnDeleteContact($filter: ModelSubscriptionContactFilterInput) {
  onDeleteContact(filter: $filter) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCreditCost = /* GraphQL */ `subscription OnDeleteCreditCost($filter: ModelSubscriptionCreditCostFilterInput) {
  onDeleteCreditCost(filter: $filter) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCreditUsageCost = /* GraphQL */ `subscription OnDeleteCreditUsageCost($filter: ModelSubscriptionCreditUsageCostFilterInput) {
  onDeleteCreditUsageCost(filter: $filter) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCustomField = /* GraphQL */ `subscription OnDeleteCustomField($filter: ModelSubscriptionCustomFieldFilterInput) {
  onDeleteCustomField(filter: $filter) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteCustomSubscription = /* GraphQL */ `subscription OnDeleteCustomSubscription($filter: ModelSubscriptionCustomSubscriptionFilterInput) {
  onDeleteCustomSubscription(filter: $filter) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteDocumentCategory = /* GraphQL */ `subscription OnDeleteDocumentCategory($filter: ModelSubscriptionDocumentCategoryFilterInput) {
  onDeleteDocumentCategory(filter: $filter) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteDocumentExtraction = /* GraphQL */ `subscription OnDeleteDocumentExtraction($filter: ModelSubscriptionDocumentExtractionFilterInput) {
  onDeleteDocumentExtraction(filter: $filter) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteDocumentNumber = /* GraphQL */ `subscription OnDeleteDocumentNumber($filter: ModelSubscriptionDocumentNumberFilterInput) {
  onDeleteDocumentNumber(filter: $filter) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteEntityAlias = /* GraphQL */ `subscription OnDeleteEntityAlias($filter: ModelSubscriptionEntityAliasFilterInput) {
  onDeleteEntityAlias(filter: $filter) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteEntityRelation = /* GraphQL */ `subscription OnDeleteEntityRelation($filter: ModelSubscriptionEntityRelationFilterInput) {
  onDeleteEntityRelation(filter: $filter) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteFeeArrears = /* GraphQL */ `subscription OnDeleteFeeArrears($filter: ModelSubscriptionFeeArrearsFilterInput) {
  onDeleteFeeArrears(filter: $filter) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteFile = /* GraphQL */ `subscription OnDeleteFile($filter: ModelSubscriptionFileFilterInput) {
  onDeleteFile(filter: $filter) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteFilterGroup = /* GraphQL */ `subscription OnDeleteFilterGroup($filter: ModelSubscriptionFilterGroupFilterInput) {
  onDeleteFilterGroup(filter: $filter) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteImportRun = /* GraphQL */ `subscription OnDeleteImportRun($filter: ModelSubscriptionImportRunFilterInput) {
  onDeleteImportRun(filter: $filter) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteIntegration = /* GraphQL */ `subscription OnDeleteIntegration($filter: ModelSubscriptionIntegrationFilterInput) {
  onDeleteIntegration(filter: $filter) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteInternalComment = /* GraphQL */ `subscription OnDeleteInternalComment($filter: ModelSubscriptionInternalCommentFilterInput) {
  onDeleteInternalComment(filter: $filter) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteInvoice = /* GraphQL */ `subscription OnDeleteInvoice($filter: ModelSubscriptionInvoiceFilterInput) {
  onDeleteInvoice(filter: $filter) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteLearningEvent = /* GraphQL */ `subscription OnDeleteLearningEvent($filter: ModelSubscriptionLearningEventFilterInput) {
  onDeleteLearningEvent(filter: $filter) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteLease = /* GraphQL */ `subscription OnDeleteLease($filter: ModelSubscriptionLeaseFilterInput) {
  onDeleteLease(filter: $filter) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteLeaseContact = /* GraphQL */ `subscription OnDeleteLeaseContact($filter: ModelSubscriptionLeaseContactFilterInput) {
  onDeleteLeaseContact(filter: $filter) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteLeasePriceHistory = /* GraphQL */ `subscription OnDeleteLeasePriceHistory($filter: ModelSubscriptionLeasePriceHistoryFilterInput) {
  onDeleteLeasePriceHistory(filter: $filter) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteNotification = /* GraphQL */ `subscription OnDeleteNotification($filter: ModelSubscriptionNotificationFilterInput) {
  onDeleteNotification(filter: $filter) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeletePaymentBatch = /* GraphQL */ `subscription OnDeletePaymentBatch($filter: ModelSubscriptionPaymentBatchFilterInput) {
  onDeletePaymentBatch(filter: $filter) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeletePaymentOrder = /* GraphQL */ `subscription OnDeletePaymentOrder($filter: ModelSubscriptionPaymentOrderFilterInput) {
  onDeletePaymentOrder(filter: $filter) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeletePosting = /* GraphQL */ `subscription OnDeletePosting($filter: ModelSubscriptionPostingFilterInput) {
  onDeletePosting(filter: $filter) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteRecurringPaymentTemplate = /* GraphQL */ `subscription OnDeleteRecurringPaymentTemplate($filter: ModelSubscriptionRecurringPaymentTemplateFilterInput) {
  onDeleteRecurringPaymentTemplate(filter: $filter) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteScheduleRule = /* GraphQL */ `subscription OnDeleteScheduleRule($filter: ModelSubscriptionScheduleRuleFilterInput) {
  onDeleteScheduleRule(filter: $filter) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteSenderRule = /* GraphQL */ `subscription OnDeleteSenderRule($filter: ModelSubscriptionSenderRuleFilterInput) {
  onDeleteSenderRule(filter: $filter) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteSendingSource = /* GraphQL */ `subscription OnDeleteSendingSource($filter: ModelSubscriptionSendingSourceFilterInput) {
  onDeleteSendingSource(filter: $filter) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteSignatureDocument = /* GraphQL */ `subscription OnDeleteSignatureDocument($filter: ModelSubscriptionSignatureDocumentFilterInput) {
  onDeleteSignatureDocument(filter: $filter) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteSubscriptionUsageHistory = /* GraphQL */ `subscription OnDeleteSubscriptionUsageHistory($filter: ModelSubscriptionSubscriptionUsageHistoryFilterInput) {
  onDeleteSubscriptionUsageHistory(filter: $filter) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteTag = /* GraphQL */ `subscription OnDeleteTag($filter: ModelSubscriptionTagFilterInput) {
  onDeleteTag(filter: $filter) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteTechnic = /* GraphQL */ `subscription OnDeleteTechnic($filter: ModelSubscriptionTechnicFilterInput) {
  onDeleteTechnic(filter: $filter) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteTechnicLibrary = /* GraphQL */ `subscription OnDeleteTechnicLibrary($filter: ModelSubscriptionTechnicLibraryFilterInput) {
  onDeleteTechnicLibrary(filter: $filter) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteTicket = /* GraphQL */ `subscription OnDeleteTicket($filter: ModelSubscriptionTicketFilterInput) {
  onDeleteTicket(filter: $filter) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteTransaction = /* GraphQL */ `subscription OnDeleteTransaction($filter: ModelSubscriptionTransactionFilterInput) {
  onDeleteTransaction(filter: $filter) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteUnit = /* GraphQL */ `subscription OnDeleteUnit($filter: ModelSubscriptionUnitFilterInput) {
  onDeleteUnit(filter: $filter) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteUnitEvent = /* GraphQL */ `subscription OnDeleteUnitEvent($filter: ModelSubscriptionUnitEventFilterInput) {
  onDeleteUnitEvent(filter: $filter) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteUnitInventory = /* GraphQL */ `subscription OnDeleteUnitInventory($filter: ModelSubscriptionUnitInventoryFilterInput) {
  onDeleteUnitInventory(filter: $filter) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteUnitLease = /* GraphQL */ `subscription OnDeleteUnitLease($filter: ModelSubscriptionUnitLeaseFilterInput) {
  onDeleteUnitLease(filter: $filter) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onDeleteUnitOwner = /* GraphQL */ `subscription OnDeleteUnitOwner($filter: ModelSubscriptionUnitOwnerFilterInput) {
  onDeleteUnitOwner(filter: $filter) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateAccountLabel = /* GraphQL */ `subscription OnUpdateAccountLabel($filter: ModelSubscriptionAccountLabelFilterInput) {
  onUpdateAccountLabel(filter: $filter) {
    id
    labels {
      language
      label
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    class
    customUsage
    customValues {
      name
      value
      __typename
    }
    disabled
    hoaFundId
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    topClass
    vatNonDeductiblePercentage
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateAddress = /* GraphQL */ `subscription OnUpdateAddress($filter: ModelSubscriptionAddressFilterInput) {
  onUpdateAddress(filter: $filter) {
    id
    status
    street
    number
    box
    postalCode
    city
    region
    country
    customValues {
      name
      value
      __typename
    }
    latitude
    longitude
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateAdminCommunication = /* GraphQL */ `subscription OnUpdateAdminCommunication($filter: ModelSubscriptionAdminCommunicationFilterInput) {
  onUpdateAdminCommunication(filter: $filter) {
    id
    body
    clientId
    externalId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    applicationInvoiceId
    recipient
    sentAt
    status
    subject
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateAdminFile = /* GraphQL */ `subscription OnUpdateAdminFile($filter: ModelSubscriptionAdminFileFilterInput) {
  onUpdateAdminFile(filter: $filter) {
    id
    bucket
    foreignKey
    foreignTableName
    key
    mimeType
    region
    size
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateApplicationInvoice = /* GraphQL */ `subscription OnUpdateApplicationInvoice($filter: ModelSubscriptionApplicationInvoiceFilterInput) {
  onUpdateApplicationInvoice(filter: $filter) {
    id
    amount
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    dueDate
    invoiceDate
    invoiceLines {
      items {
        id
        amountVatExcluded
        applicationInvoiceId
        calculationMethod
        clientId
        customLabel
        extraInformation
        quantity
        periodFrom
        periodTo
        subscriptionVariousOperationId
        subscriptionUsageHistoryId
        totalAmount
        type
        vatAmount
        vatRate
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoiceNumber
    periodFrom
    periodTo
    clientSnapshot {
      name
      vat
      businessNumber
      email
      address {
        street
        number
        box
        postalCode
        city
        country
        __typename
      }
      __typename
    }
    peppolProperties {
      peppolStatus
      peppolId
      peppolErrorType
      peppolErrorMessage
      __typename
    }
    status
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateApplicationInvoiceLine = /* GraphQL */ `subscription OnUpdateApplicationInvoiceLine($filter: ModelSubscriptionApplicationInvoiceLineFilterInput) {
  onUpdateApplicationInvoiceLine(filter: $filter) {
    id
    amountVatExcluded
    applicationInvoiceId
    applicationInvoice {
      id
      amount
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      dueDate
      invoiceDate
      invoiceLines {
        nextToken
        startedAt
        __typename
      }
      invoiceNumber
      periodFrom
      periodTo
      clientSnapshot {
        name
        vat
        businessNumber
        email
        __typename
      }
      peppolProperties {
        peppolStatus
        peppolId
        peppolErrorType
        peppolErrorMessage
        __typename
      }
      status
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    calculationDetail {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    clientId
    customLabel
    extraInformation
    quantity
    periodFrom
    periodTo
    subscriptionVariousOperationId
    subscriptionVariousOperation {
      id
      applicationSubscriptionId
      applicationSubscription {
        id
        clientId
        creditsBalancePaid
        creditsBalanceIncluded
        endDate
        language
        lastInvoiceDate
        paymentCustomerId
        paymentLastExecution
        paymentLastStatus
        paymentLastError
        paymentMode
        paymentTerms
        planId
        referenceNumber
        sellerId
        startDate
        status
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientId
      createdBy {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      endDate
      label
      lastInvoiceDate
      sellerId
      startDate
      subscriptionVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      type
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    subscriptionUsageHistoryId
    subscriptionUsageHistory {
      id
      clientId
      creditUsageDetail {
        numberUsed
        creditsAccount
        creditOperationType
        __typename
      }
      customerCreatorId
      requestId
      applicationInvoiceId
      storageUsageDetail {
        numberUsed
        __typename
      }
      type
      unitsUsageDetail {
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    totalAmount
    type
    vatAmount
    vatRate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateApplicationPlan = /* GraphQL */ `subscription OnUpdateApplicationPlan($filter: ModelSubscriptionApplicationPlanFilterInput) {
  onUpdateApplicationPlan(filter: $filter) {
    id
    calculationDetails {
      amountType
      endNumber
      feeApplied
      minimumFixedUnitPriceThreshold
      startNumber
      unitType
      __typename
    }
    calculationMethod
    includedVariousOperations {
      items {
        id
        amount
        applicationPlanIncludedVariousOperationsId
        customerVisible
        duration
        numberOfCredits
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    isBillable
    isDefaultPlan
    labels {
      language
      label
      __typename
    }
    numberOfTrialMonths
    setupFees
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateApplicationSubscription = /* GraphQL */ `subscription OnUpdateApplicationSubscription($filter: ModelSubscriptionApplicationSubscriptionFilterInput) {
  onUpdateApplicationSubscription(filter: $filter) {
    id
    clientId
    creditsBalancePaid
    creditsBalanceIncluded
    creditsConfiguration {
      allowPostPaid
      creditsNotification
      postPaidThreshold
      __typename
    }
    endDate
    language
    lastInvoiceDate
    paymentCustomerId
    paymentLastExecution
    paymentLastStatus
    paymentLastError
    paymentMode
    paymentTerms
    invoicesProperties {
      hideQuantities
      __typename
    }
    plan {
      id
      calculationDetails {
        amountType
        endNumber
        feeApplied
        minimumFixedUnitPriceThreshold
        startNumber
        unitType
        __typename
      }
      calculationMethod
      includedVariousOperations {
        nextToken
        startedAt
        __typename
      }
      isBillable
      isDefaultPlan
      labels {
        language
        label
        __typename
      }
      numberOfTrialMonths
      setupFees
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    planId
    referenceNumber
    seller {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    sellerId
    startDate
    status
    subscriptionVariousOperations {
      items {
        id
        applicationSubscriptionId
        clientId
        endDate
        label
        lastInvoiceDate
        sellerId
        startDate
        type
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateApplicationSubscriptionVariousOperation = /* GraphQL */ `subscription OnUpdateApplicationSubscriptionVariousOperation($filter: ModelSubscriptionApplicationSubscriptionVariousOperationFilterInput) {
  onUpdateApplicationSubscriptionVariousOperation(filter: $filter) {
    id
    applicationSubscriptionId
    applicationSubscription {
      id
      clientId
      creditsBalancePaid
      creditsBalanceIncluded
      creditsConfiguration {
        allowPostPaid
        creditsNotification
        postPaidThreshold
        __typename
      }
      endDate
      language
      lastInvoiceDate
      paymentCustomerId
      paymentLastExecution
      paymentLastStatus
      paymentLastError
      paymentMode
      paymentTerms
      invoicesProperties {
        hideQuantities
        __typename
      }
      plan {
        id
        calculationMethod
        isBillable
        isDefaultPlan
        numberOfTrialMonths
        setupFees
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      planId
      referenceNumber
      seller {
        id
        cognitoSub
        email
        firstName
        language
        lastName
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      sellerId
      startDate
      status
      subscriptionVariousOperations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientId
    createdBy {
      id
      cognitoSub
      email
      firstName
      language
      lastName
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    endDate
    label
    lastInvoiceDate
    sellerId
    startDate
    subscriptionVariousOperationHistories {
      periodFrom
      periodTo
      amount
      __typename
    }
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateApplicationVariousOperation = /* GraphQL */ `subscription OnUpdateApplicationVariousOperation($filter: ModelSubscriptionApplicationVariousOperationFilterInput) {
  onUpdateApplicationVariousOperation(filter: $filter) {
    id
    amount
    applicationPlanIncludedVariousOperationsId
    customerVisible
    duration
    labels {
      language
      label
      __typename
    }
    numberOfCredits
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateBankAccount = /* GraphQL */ `subscription OnUpdateBankAccount($filter: ModelSubscriptionBankAccountFilterInput) {
  onUpdateBankAccount(filter: $filter) {
    id
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactIds
    buildingIds
    number
    bicNumber
    bankName
    holderName
    label
    customValues {
      name
      value
      __typename
    }
    disabled
    integrations
    matchingRule
    initiationChannel
    retainedBalanceThreshold
    balance
    balanceDate
    type
    ibanStatus
    ibanVerifiedAt
    ibanVerifiedBy
    ibanVerifiedNumber
    ibanVerifiedSourceDocumentId
    ibanRole
    ibanRoleLabel
    isDefault
    note
    paymentRunPriorityOrderIds
    paymentRunPriorityUpdatedAt
    paymentRunPriorityUpdatedBy
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateBillingItem = /* GraphQL */ `subscription OnUpdateBillingItem($filter: ModelSubscriptionBillingItemFilterInput) {
  onUpdateBillingItem(filter: $filter) {
    id
    name
    baseAmount
    billingType
    amountCalculationType
    percentageBase
    period
    vatRateId
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    quantity
    percentage
    allocationOption
    multipleUnitsSplit
    leaseIds
    unitIds
    buildingIds
    accountLabelId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateBuilding = /* GraphQL */ `subscription OnUpdateBuilding($filter: ModelSubscriptionBuildingFilterInput) {
  onUpdateBuilding(filter: $filter) {
    id
    name
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    acquisitionValue
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    amountOfFacades
    amountOfFloors
    amountOfHousings
    buildingState
    cadastralIncome
    constructionYear
    customValues {
      name
      value
      __typename
    }
    janitor
    jointOwnershipId
    notes
    owners {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    propertyTax
    residenceName
    buildingSiteId
    buildingSite {
      id
      name
      buildings {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    units {
      items {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        buildingId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateBuildingEvent = /* GraphQL */ `subscription OnUpdateBuildingEvent($filter: ModelSubscriptionBuildingEventFilterInput) {
  onUpdateBuildingEvent(filter: $filter) {
    id
    buildingId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateBuildingOwner = /* GraphQL */ `subscription OnUpdateBuildingOwner($filter: ModelSubscriptionBuildingOwnerFilterInput) {
  onUpdateBuildingOwner(filter: $filter) {
    id
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    periodTo
    stake
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateBuildingSite = /* GraphQL */ `subscription OnUpdateBuildingSite($filter: ModelSubscriptionBuildingSiteFilterInput) {
  onUpdateBuildingSite(filter: $filter) {
    id
    name
    buildings {
      items {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    teams
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCause = /* GraphQL */ `subscription OnUpdateCause($filter: ModelSubscriptionCauseFilterInput) {
  onUpdateCause(filter: $filter) {
    id
    distinctValues {
      candidates {
        reason
        targetId
        __typename
      }
      display
      sectionIds
      value
      __typename
    }
    importRunId
    key
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCharge = /* GraphQL */ `subscription OnUpdateCharge($filter: ModelSubscriptionChargeFilterInput) {
  onUpdateCharge(filter: $filter) {
    id
    status
    invoiceDate
    paymentDueDate
    archivedDate
    periodFrom
    periodTo
    totalAmount
    payableAmount
    source
    draftFromOcr
    accountingDocumentId
    paid
    settlement {
      bankCheck
      modeResolved
      modeSource
      parts {
        amount
        executeOn
        kind
        reference
        __typename
      }
      __typename
    }
    remittanceInformation
    note
    creatorEmail
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contractorId
    contractor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedContractors {
      id
      confidence
      __typename
    }
    recipientId
    recipient {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    proposedRecipients {
      id
      confidence
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    documentId
    sectionId
    document {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readId
    clientId
    openChargeClientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateChargeEnvelope = /* GraphQL */ `subscription OnUpdateChargeEnvelope($filter: ModelSubscriptionChargeEnvelopeFilterInput) {
  onUpdateChargeEnvelope(filter: $filter) {
    id
    channel
    decryptedS3Key
    duplicateOfEnvelopeId
    encryption
    fileHash
    fileId
    file {
      id
      bucket
      category {
        id
        entity
        fileCategory
        parentId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      categoryId
      foreignKey
      foreignTableName
      key
      mimeType
      region
      signaturePositions {
        top
        left
        page
        width
        height
        contactId
        __typename
      }
      size
      readers
      readId
      clientId
      _ttl
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    importRunId
    mimeType
    originalFileName
    pageQuality {
      alphaRatio
      averageFontSize
      dictionaryHits
      kind
      page
      __typename
    }
    pages
    readFailure
    receivedAt
    s3Key
    sections {
      items {
        id
        attachedToSectionId
        chargeId
        envelopeId
        excludedPages
        fallbackIdentityKey
        genre
        genreSubKind
        identityKey
        index
        issueDate
        issuerDateKey
        issuerNumberKey
        readFailure
        setAsideReason
        splitSource
        state
        valuesFromSectionId
        resolvedAliases
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    setAsideReason
    splitProposal {
      ambiguousBoundaries
      autoApplied
      cuts {
        afterPage
        reason
        rule
        score
        __typename
      }
      proposedAt
      source
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateChargeSection = /* GraphQL */ `subscription OnUpdateChargeSection($filter: ModelSubscriptionChargeSectionFilterInput) {
  onUpdateChargeSection(filter: $filter) {
    id
    attachedToSectionId
    chargeId
    checkpoints {
      allocate
      pay
      payReasons
      read
      resolve
      sort
      tenant
      __typename
    }
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    duplicateCandidates {
      reason
      sectionId
      __typename
    }
    envelopeId
    envelope {
      id
      channel
      decryptedS3Key
      duplicateOfEnvelopeId
      encryption
      fileHash
      fileId
      file {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      importRunId
      mimeType
      originalFileName
      pageQuality {
        alphaRatio
        averageFontSize
        dictionaryHits
        kind
        page
        __typename
      }
      pages
      readFailure
      receivedAt
      s3Key
      sections {
        nextToken
        startedAt
        __typename
      }
      setAsideReason
      splitProposal {
        ambiguousBoundaries
        autoApplied
        proposedAt
        source
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    excludedPages
    fallbackIdentityKey
    genre
    genreCandidates {
      genre
      reasons
      score
      __typename
    }
    genreSubKind
    identity {
      documentNumber
      grossTotal
      issuer
      source
      values {
        field
        value
        __typename
      }
      __typename
    }
    identityKey
    index
    issueDate
    issuerDateKey
    issuerNumberKey
    readFailure
    pageRange {
      from
      to
      __typename
    }
    renderings {
      attachedAt
      differences {
        field
        renderingValue
        survivorValue
        __typename
      }
      envelopeId
      reason
      sectionId
      source
      __typename
    }
    setAsideReason
    splitSource
    state
    valuesFromSectionId
    resolvedAliases
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCommunication = /* GraphQL */ `subscription OnUpdateCommunication($filter: ModelSubscriptionCommunicationFilterInput) {
  onUpdateCommunication(filter: $filter) {
    id
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    blockedRecipients {
      recipient
      bounceType
      __typename
    }
    body
    buildingId
    channel
    communicationTemplateId
    concernedContactIds
    contactId
    contactIds
    deliveredAt
    draftProperties {
      entityType
      leaseIds
      unitIds
      buildingIds
      contactIds
      contactTypes
      sendInBcc
      cc
      bcc
      allowRecipientsToSeeEachOther
      unitTypeFilter
      __typename
    }
    errorCode
    expirationDate
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    leasePriceHistoryId
    leasePriceHistory {
      id
      previousTotalRentalPrice
      totalRentalPrice
      optimalTotalRentalPrice
      optimalTotalMonthlyCharges
      applicationDate
      status
      comment
      amountDetails {
        unitId
        indexationBaseIndex
        indexationNewIndex
        previousRentalPrice
        newRentalPrice
        rentalStatus
        monthlyChargesStatus
        optimalNewRentalPrice
        optimalNewMonthlyChargesPrice
        epb
        epbIssueDate
        oldestIndexForCorrectionFactorCalculation
        newestIndexForCorrectionFactorCalculation
        rentIndexedPriceAfterNewEpbReduction
        chargesIndexedPriceAfterNewEpbReduction
        correctionFactor
        reductionPercentage
        rentDifference
        rentReduction
        indexedRentAfterReduction
        chargesDifference
        chargesReduction
        indexedChargesAfterReduction
        previousYearIndexationNewIndex
        previousYearIndexedRent
        previousYearIndexedCharges
        __typename
      }
      type
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    letterTrackingCode
    letterTrackingProvider
    linkedCommunicationsIds
    nextRetryAt
    recipient
    recipientContactIdsInBcc
    recipientContactIdsInCc
    recipientInBcc
    recipientInCc
    scheduledAt
    sender
    sendRetryCount
    sentAt
    externalId
    externalStatus
    signatureDocumentId
    signatureDocument {
      id
      additionalMessage
      automaticRemindersDisabled
      communicationBody
      expirationDate
      fileIds
      foreignKey
      foreignTableName
      sentAt
      signatureMethods
      signatureResults {
        openedDate
        signedDate
        signed
        signatureLink
        rejectReason
        lastSignInviteSentDate
        reminderDates
        trackingProvider
        trackingCode
        contactId
        __typename
      }
      status
      externalStatus
      type
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    snoozedDate
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    status
    subject
    supportingDocumentFileIds
    toSend
    hideLogo
    type
    _ttl
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCommunicationSettingsProfile = /* GraphQL */ `subscription OnUpdateCommunicationSettingsProfile($filter: ModelSubscriptionCommunicationSettingsProfileFilterInput) {
  onUpdateCommunicationSettingsProfile(filter: $filter) {
    id
    communicationsSettings {
      channels
      communicationType
      daysBeforeDueDate
      daysOverdue
      invoiceDaysAfterPeriodStart
      frequency {
        dateFrom
        periodInterval
        periodType
        __typename
      }
      sendingRule
      recipients
      recipientsInBcc
      recipientsInCopy
      displayOpenBalance
      __typename
    }
    defaultName
    isDefaultSetting
    referent
    tenantStatementView
    replacementId
    displayLogo
    readId
    readers
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCompanyUser = /* GraphQL */ `subscription OnUpdateCompanyUser($filter: ModelSubscriptionCompanyUserFilterInput) {
  onUpdateCompanyUser(filter: $filter) {
    id
    cognitoSub
    email
    firstName
    language
    lastName
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateContact = /* GraphQL */ `subscription OnUpdateContact($filter: ModelSubscriptionContactFilterInput) {
  onUpdateContact(filter: $filter) {
    id
    firstName
    lastName
    companyName
    commercialName
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    businessNumber
    types
    vat
    emails {
      address
      isPrimary
      label
      __typename
    }
    email
    birthDate
    birthPlace
    nationalRegister
    ipiNumber
    insuranceCompany
    insuranceContractNumber
    judicialDistrict
    civility
    addressId
    address {
      id
      status
      street
      number
      box
      postalCode
      city
      region
      country
      customValues {
        name
        value
        __typename
      }
      latitude
      longitude
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    phoneNumbers {
      countryCode
      isPrimary
      label
      number
      __typename
    }
    language
    notes
    profileType
    jointOwners {
      contactId
      contactPerson
      __typename
    }
    hoaFunds {
      archivedAt
      id
      kind
      name
      __typename
    }
    paymentTermDays
    acpSyndicEras {
      syndicContactId
      validFrom
      validTo
      __typename
    }
    acpSyndicHistory {
      changedAt
      changedBy
      previousSyndicContactId
      previousValidFrom
      syndicContactId
      validFrom
      __typename
    }
    defaultBankAccountId
    supplierPaymentMode
    supplierPaymentModeExceptions {
      confirmedAt
      confirmedBy
      mode
      ownerId
      __typename
    }
    supplierPaymentModeHistory {
      changedAt
      changedBy
      mode
      ownerId
      previousMode
      __typename
    }
    agencyRateDisabled
    attachStatementSupportingDocuments
    status
    leases {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildings {
      items {
        id
        buildingId
        contactId
        disabled
        periodFrom
        periodTo
        stake
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    sendInvitation
    peppolProperties {
      isRegistered
      mustSend
      __typename
    }
    integrations {
      paymentProperties {
        accountId
        __typename
      }
      __typename
    }
    readers
    readId
    clientId
    sourceEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    foreignEntityRelations {
      items {
        id
        sourceId
        sourceTableName
        foreignId
        foreignTableName
        linkDescription
        clientId
        readers
        readId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCreditCost = /* GraphQL */ `subscription OnUpdateCreditCost($filter: ModelSubscriptionCreditCostFilterInput) {
  onUpdateCreditCost(filter: $filter) {
    id
    clientId
    endDate
    numberOfCredits
    price
    startDate
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCreditUsageCost = /* GraphQL */ `subscription OnUpdateCreditUsageCost($filter: ModelSubscriptionCreditUsageCostFilterInput) {
  onUpdateCreditUsageCost(filter: $filter) {
    id
    endDate
    numberOfCreditsPerOperation
    startDate
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCustomField = /* GraphQL */ `subscription OnUpdateCustomField($filter: ModelSubscriptionCustomFieldFilterInput) {
  onUpdateCustomField(filter: $filter) {
    id
    fieldName
    fieldType
    foreignKey
    foreignTableName
    labels {
      language
      label
      __typename
    }
    customFieldProperties {
      isRequired
      isDefault
      defaultValue
      options {
        id
        __typename
      }
      __typename
    }
    order
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateCustomSubscription = /* GraphQL */ `subscription OnUpdateCustomSubscription($filter: ModelSubscriptionCustomSubscriptionFilterInput) {
  onUpdateCustomSubscription(filter: $filter) {
    id
    name
    value
    userId
    _ttl
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateDocumentCategory = /* GraphQL */ `subscription OnUpdateDocumentCategory($filter: ModelSubscriptionDocumentCategoryFilterInput) {
  onUpdateDocumentCategory(filter: $filter) {
    id
    entity
    fileCategory
    labels {
      language
      label
      __typename
    }
    parentId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateDocumentExtraction = /* GraphQL */ `subscription OnUpdateDocumentExtraction($filter: ModelSubscriptionDocumentExtractionFilterInput) {
  onUpdateDocumentExtraction(filter: $filter) {
    id
    corrected
    createdBy
    evidence {
      bbox
      field
      method
      page
      quote
      rawConfidence
      __typename
    }
    flags
    raw
    reasons
    score
    sectionId
    version
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateDocumentNumber = /* GraphQL */ `subscription OnUpdateDocumentNumber($filter: ModelSubscriptionDocumentNumberFilterInput) {
  onUpdateDocumentNumber(filter: $filter) {
    id
    format
    lastUpdate
    incrementNumber
    type
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateEntityAlias = /* GraphQL */ `subscription OnUpdateEntityAlias($filter: ModelSubscriptionEntityAliasFilterInput) {
  onUpdateEntityAlias(filter: $filter) {
    id
    confirmations
    confirmedBy
    key
    kind
    lastSeenAt
    lookupKey
    printedValue
    senderKeyType
    source
    targetId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateEntityRelation = /* GraphQL */ `subscription OnUpdateEntityRelation($filter: ModelSubscriptionEntityRelationFilterInput) {
  onUpdateEntityRelation(filter: $filter) {
    id
    sourceId
    sourceTableName
    foreignId
    foreignTableName
    linkDescription
    linkProperties {
      contact {
        communicationSubscriptions
        __typename
      }
      __typename
    }
    clientId
    readers
    readId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateFeeArrears = /* GraphQL */ `subscription OnUpdateFeeArrears($filter: ModelSubscriptionFeeArrearsFilterInput) {
  onUpdateFeeArrears(filter: $filter) {
    id
    accumulatedFrom {
      accumulatedAt
      amount
      paymentOrderId
      __typename
    }
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    openedAt
    originalAmount
    originPaymentOrderId
    originPaymentOrder {
      id
      amount
      anomalies
      anomalyAcknowledgedAt
      anomalyAcknowledgedBy
      anomalyPreviousIban
      anomalyReferenceAmount
      approvedAt
      approvedBy
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      cancelledAt
      cancelledBy
      cancelReasonCode
      channel
      confirmationDeadlineDate
      counterpartAccountNumber
      counterpartContactId
      counterpartAccountUpdatedAt
      counterpartAccountUpdatedBy
      counterpartContact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartRemittanceInformation
      createdBy
      dueDate
      executedDate
      executedAt
      executedBy
      executedTransactionId
      feeArrearsId
      fixedAt
      fixedBy
      fundAllocations {
        accountLabelId
        amount
        fundId
        kind
        __typename
      }
      fundAmounts {
        reserveFundAmount
        workingCapitalAmount
        __typename
      }
      invoiceId
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issuedAt
      issuedBy
      ownerContactId
      paymentBatchId
      paymentBatch {
        id
        bankAccountId
        clientStatusKey
        currentVersion
        number
        outdated
        sentAt
        sentBy
        status
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      periodFrom
      reconciledAt
      recurringPaymentTemplateId
      reference
      reissuedFromOrderId
      reissuedOrderId
      rejectedAt
      rejectedBy
      rejectedField
      rejectedReason
      requestedAmount
      reroutedAt
      reroutedBy
      reroutedFromBankAccountId
      status
      submittedAt
      submittedBy
      suggestion {
        original
        suggested
        reason
        __typename
      }
      suggestionDeclinedReason
      suggestionResolved
      tenantRechargeableRatio
      type
      unitId
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerContactId
    ownerContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    servedBy {
      amount
      paymentOrderId
      servedAt
      __typename
    }
    settledAt
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateFile = /* GraphQL */ `subscription OnUpdateFile($filter: ModelSubscriptionFileFilterInput) {
  onUpdateFile(filter: $filter) {
    id
    bucket
    category {
      id
      entity
      fileCategory
      labels {
        language
        label
        __typename
      }
      parentId
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    categoryId
    foreignKey
    foreignTableName
    key
    mimeType
    region
    signaturePositions {
      top
      left
      page
      width
      height
      contactId
      __typename
    }
    size
    readers
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateFilterGroup = /* GraphQL */ `subscription OnUpdateFilterGroup($filter: ModelSubscriptionFilterGroupFilterInput) {
  onUpdateFilterGroup(filter: $filter) {
    id
    filterGroupDetails {
      filterEntityType
      filterEntityField
      filterEntityValues
      filterEntityNumber
      filterEntityDate
      __typename
    }
    name
    screenName
    type
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateImportRun = /* GraphQL */ `subscription OnUpdateImportRun($filter: ModelSubscriptionImportRunFilterInput) {
  onUpdateImportRun(filter: $filter) {
    id
    channel
    files
    finishedAt
    handled
    needsYou
    reviewEverything
    sections
    setAside
    startedAt
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateIntegration = /* GraphQL */ `subscription OnUpdateIntegration($filter: ModelSubscriptionIntegrationFilterInput) {
  onUpdateIntegration(filter: $filter) {
    id
    configurations {
      name
      value
      __typename
    }
    error
    lastRun
    name
    status
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateInternalComment = /* GraphQL */ `subscription OnUpdateInternalComment($filter: ModelSubscriptionInternalCommentFilterInput) {
  onUpdateInternalComment(filter: $filter) {
    id
    authorId
    content
    entityId
    entityType
    kind
    mentionedUserIds
    userIdsReactions {
      reactionType
      userId
      __typename
    }
    replyToId
    attachmentFileIds
    systemMessage
    systemMessageParameters
    readId
    clientId
    _ttl
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateInvoice = /* GraphQL */ `subscription OnUpdateInvoice($filter: ModelSubscriptionInvoiceFilterInput) {
  onUpdateInvoice(filter: $filter) {
    id
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    creditNote
    creditNoteLabel
    customValues {
      name
      value
      __typename
    }
    disputedPostingIds
    disputes {
      id
      scope
      postingId
      postingLabel
      reason
      comment
      disputedOn
      openedAt
      openedById
      openDecisionId
      liftedAt
      liftedById
      liftCause
      liftDecisionId
      __typename
    }
    disputeStatus
    dueDate
    invoiceDate
    invoiceNumber
    ownerId
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    paid
    integrations {
      paymentProperties {
        availableOn
        error
        feeAmount
        paymentIntentId
        paymentLinkAmount
        paymentLinkUrl
        payoutId
        statementDescriptor
        __typename
      }
      __typename
    }
    lastValidatedAt
    note
    postedDate
    purchaseOrderNumber
    receiptNumber
    reminderDates
    remittanceInformation
    reversedInvoiceId
    sentVersions {
      version
      sentAt
      invoiceNumber
      invoiceSenderId
      channels {
        channel
        status
        communicationId
        peppolId
        __typename
      }
      pdfFileId
      xmlFileId
      resetAt
      resetBy
      reason
      __typename
    }
    statementId
    statement {
      id
      amounts {
        name
        value
        __typename
      }
      attachSupportingDocuments
      chargeStatements {
        nextToken
        startedAt
        __typename
      }
      closingStatement
      periodFrom
      periodTo
      selectedPocketKeys
      source
      status
      sentDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      agencyRateStatements {
        nextToken
        startedAt
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      repaymentStatements {
        nextToken
        startedAt
        __typename
      }
      types
      viewType
      unitIds
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    status
    type
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateLearningEvent = /* GraphQL */ `subscription OnUpdateLearningEvent($filter: ModelSubscriptionLearningEventFilterInput) {
  onUpdateLearningEvent(filter: $filter) {
    id
    at
    field
    from
    kind
    layoutId
    senderId
    to
    userId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateLease = /* GraphQL */ `subscription OnUpdateLease($filter: ModelSubscriptionLeaseFilterInput) {
  onUpdateLease(filter: $filter) {
    id
    advancedChargesInvoices {
      communicationSettingsProfileId
      invoiceSenderId
      lastDraftInvoiceDate
      lastInvoiceDate
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      remittanceInformation
      remittanceInformationType
      bankAccountId
      __typename
    }
    balance
    canBeExtended
    communicationSettingsProfileId
    customValues {
      name
      value
      __typename
    }
    endDate
    includeRealEstateInLeaseContract
    invoiceSenderId
    invoiceSender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    inventoryOfFixturesExpert
    inventoryOfFixturesMethod
    inventoryOfFixturesType
    ipiNumber
    language
    lastDraftInvoiceDate
    lastIndexationProcessDate
    lastInvoiceDate
    legalCompetentAuthority
    name
    notes
    paymentFrequency
    paymentInvoicePeriod
    paymentInvoicePeriodCustomDay
    paymentOption {
      enabled
      mandateStatus
      mandateActivatedAt
      customerId
      paymentMethodId
      qrType
      __typename
    }
    purchaseOrderNumber
    realEstateAgency
    realEstateTax
    remittanceInformation
    remittanceInformationType
    rentalGuaranty {
      amount
      blockedAmount
      releasedAmount
      type
      financialInstitution
      __typename
    }
    signatureDate
    startDate
    nextIndexationMonth
    nextIndexation
    status
    subletting
    technicCommunicationSettingsProfileId
    totalInitialRentalPrice
    totalRentalPrice
    type
    vatRateRentId
    vatRateRent {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    additionalClauses {
      items {
        id
        leaseId
        title
        body
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    attachStatementSupportingDocuments
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contacts {
      items {
        id
        leaseId
        contactId
        contactRole
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leaseActionHistories {
      items {
        id
        action
        comment
        contactId
        leaseId
        communicationId
        signatureDocumentId
        status
        communicationChannel
        communicationSendDate
        communicationByPlatform
        endReason
        endReasonOwnUseRelation
        endReasonOwnUseName
        initiator
        totalAmount
        totalAmountLabel
        automatic
        hasLeaseTypeChanged
        jiraId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leasePriceHistories {
      items {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    signatureDocuments {
      items {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    units {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    variousOperations {
      items {
        id
        accountLabelIds
        amount
        billingMode
        contactId
        dueDateDaysAfterPeriodStart
        endDate
        indexationBaseAmount
        indexationBaseIndexDate
        indexationFrozen
        invoiceSenderId
        issueLeadDays
        label
        lastInvoiceDate
        leaseId
        operationType
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        periodNature
        reason
        separateInvoice
        startDate
        type
        unitId
        vatRateId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateLeaseContact = /* GraphQL */ `subscription OnUpdateLeaseContact($filter: ModelSubscriptionLeaseContactFilterInput) {
  onUpdateLeaseContact(filter: $filter) {
    id
    leaseId
    contactId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactRole
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateLeasePriceHistory = /* GraphQL */ `subscription OnUpdateLeasePriceHistory($filter: ModelSubscriptionLeasePriceHistoryFilterInput) {
  onUpdateLeasePriceHistory(filter: $filter) {
    id
    previousTotalRentalPrice
    totalRentalPrice
    optimalTotalRentalPrice
    optimalTotalMonthlyCharges
    applicationDate
    status
    comment
    amountDetails {
      unitId
      indexationBaseIndex
      indexationNewIndex
      previousRentalPrice
      newRentalPrice
      rentalStatus
      monthlyChargesStatus
      optimalNewRentalPrice
      optimalNewMonthlyChargesPrice
      epb
      epbIssueDate
      oldestIndexForCorrectionFactorCalculation
      newestIndexForCorrectionFactorCalculation
      rentIndexedPriceAfterNewEpbReduction
      chargesIndexedPriceAfterNewEpbReduction
      correctionFactor
      chargesAmountsDetails {
        leaseVariousOperationId
        previousMonthlyAmount
        newMonthlyAmount
        indexationBaseIndex
        indexationBaseAmount
        indexationBaseIndexDate
        indexed
        __typename
      }
      reductionPercentage
      rentDifference
      rentReduction
      indexedRentAfterReduction
      chargesDifference
      chargesReduction
      indexedChargesAfterReduction
      previousYearIndexationNewIndex
      previousYearIndexedRent
      previousYearIndexedCharges
      __typename
    }
    type
    communicationId
    communication {
      id
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      blockedRecipients {
        recipient
        bounceType
        __typename
      }
      body
      buildingId
      channel
      communicationTemplateId
      concernedContactIds
      contactId
      contactIds
      deliveredAt
      draftProperties {
        entityType
        leaseIds
        unitIds
        buildingIds
        contactIds
        contactTypes
        sendInBcc
        cc
        bcc
        allowRecipientsToSeeEachOther
        unitTypeFilter
        __typename
      }
      errorCode
      expirationDate
      files {
        nextToken
        startedAt
        __typename
      }
      invoice {
        id
        amount
        bankAccountId
        communicationId
        creditNote
        creditNoteLabel
        disputedPostingIds
        disputeStatus
        dueDate
        invoiceDate
        invoiceNumber
        ownerId
        invoiceSenderId
        leaseId
        paid
        lastValidatedAt
        note
        postedDate
        purchaseOrderNumber
        receiptNumber
        reminderDates
        remittanceInformation
        reversedInvoiceId
        statementId
        status
        type
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      leasePriceHistoryId
      leasePriceHistory {
        id
        previousTotalRentalPrice
        totalRentalPrice
        optimalTotalRentalPrice
        optimalTotalMonthlyCharges
        applicationDate
        status
        comment
        type
        communicationId
        leaseId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      letterTrackingCode
      letterTrackingProvider
      linkedCommunicationsIds
      nextRetryAt
      recipient
      recipientContactIdsInBcc
      recipientContactIdsInCc
      recipientInBcc
      recipientInCc
      scheduledAt
      sender
      sendRetryCount
      sentAt
      externalId
      externalStatus
      signatureDocumentId
      signatureDocument {
        id
        additionalMessage
        automaticRemindersDisabled
        communicationBody
        expirationDate
        fileIds
        foreignKey
        foreignTableName
        sentAt
        signatureMethods
        status
        externalStatus
        type
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      snoozedDate
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      statementId
      status
      subject
      supportingDocumentFileIds
      toSend
      hideLogo
      type
      _ttl
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateNotification = /* GraphQL */ `subscription OnUpdateNotification($filter: ModelSubscriptionNotificationFilterInput) {
  onUpdateNotification(filter: $filter) {
    id
    createdBy
    type
    message
    popupDate
    expirationDate
    status
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicId
    technic {
      id
      type
      technicLibraryId
      technicLibrary {
        id
        communicationSettingsProfileId
        criticality
        isDefault
        issuingAuthority
        linkedCertificateIds
        locationScope
        status
        tagIds
        technicLibraryFormat
        type
        utilityTypes
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      technicName
      lastControlDate
      status
      contractNumber
      communicationSettingsProfileId
      maintenanceHistory {
        date
        contactId
        fileId
        id
        maintenanceSchemaId
        __typename
      }
      utilityType
      utilityEanCode
      utilityMeterNumber
      utilityDistributorId
      utilityDistributor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      utilityHistory {
        date
        reason
        reading
        secondReading
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      originalTechnicId
      replacedTechnicId
      certificateIds
      readers
      writers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ticketId
    ticket {
      id
      assignedAt
      assignedTo {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      assignedToId
      attachment {
        nextToken
        startedAt
        __typename
      }
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      buildingId
      closedAt
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      content
      conversations {
        nextToken
        startedAt
        __typename
      }
      emailMessageId
      emailReferences
      parentId
      plannedAt
      referenceCode
      sourceType
      status
      subject
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      unread
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdatePaymentBatch = /* GraphQL */ `subscription OnUpdatePaymentBatch($filter: ModelSubscriptionPaymentBatchFilterInput) {
  onUpdatePaymentBatch(filter: $filter) {
    id
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    clientStatusKey
    currentVersion
    number
    outdated
    sentAt
    sentBy
    status
    versions {
      version
      exclusions {
        orderId
        reason
        __typename
      }
      fileKey
      fingerprint
      generatedAt
      generatedBy
      orderCount
      totalAmount
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdatePaymentOrder = /* GraphQL */ `subscription OnUpdatePaymentOrder($filter: ModelSubscriptionPaymentOrderFilterInput) {
  onUpdatePaymentOrder(filter: $filter) {
    id
    amount
    anomalies
    anomalyAcknowledgedAt
    anomalyAcknowledgedBy
    anomalyPreviousIban
    anomalyReferenceAmount
    approvedAt
    approvedBy
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    cancelledAt
    cancelledBy
    cancelReasonCode
    channel
    confirmationDeadlineDate
    counterpartAccountNumber
    counterpartContactId
    counterpartAccountUpdatedAt
    counterpartAccountUpdatedBy
    counterpartContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartRemittanceInformation
    createdBy
    dueDate
    executedDate
    executedAt
    executedBy
    executedTransactionId
    feeArrearsId
    fixedAt
    fixedBy
    fundAllocations {
      accountLabelId
      amount
      fundId
      kind
      __typename
    }
    fundAmounts {
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    issuedAt
    issuedBy
    ownerContactId
    paymentBatchId
    paymentBatch {
      id
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      clientStatusKey
      currentVersion
      number
      outdated
      sentAt
      sentBy
      status
      versions {
        version
        fileKey
        fingerprint
        generatedAt
        generatedBy
        orderCount
        totalAmount
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    periodFrom
    reconciledAt
    recurringPaymentTemplateId
    reference
    reissuedFromOrderId
    reissuedOrderId
    rejectedAt
    rejectedBy
    rejectedField
    rejectedReason
    requestedAmount
    reroutedAt
    reroutedBy
    reroutedFromBankAccountId
    status
    submittedAt
    submittedBy
    suggestion {
      original
      suggested
      reason
      __typename
    }
    suggestionDeclinedReason
    suggestionResolved
    tenantRechargeableRatio
    type
    unitId
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdatePosting = /* GraphQL */ `subscription OnUpdatePosting($filter: ModelSubscriptionPostingFilterInput) {
  onUpdatePosting(filter: $filter) {
    id
    class
    customLabel
    customValues {
      name
      value
      __typename
    }
    topClass
    type
    totalAmount
    periodFrom
    periodTo
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    invoiceId
    invoice {
      id
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      communicationId
      communication {
        id
        addressId
        body
        buildingId
        channel
        communicationTemplateId
        concernedContactIds
        contactId
        contactIds
        deliveredAt
        errorCode
        expirationDate
        invoiceId
        leaseId
        leasePriceHistoryId
        letterTrackingCode
        letterTrackingProvider
        linkedCommunicationsIds
        nextRetryAt
        recipient
        recipientContactIdsInBcc
        recipientContactIdsInCc
        recipientInBcc
        recipientInCc
        scheduledAt
        sender
        sendRetryCount
        sentAt
        externalId
        externalStatus
        signatureDocumentId
        snoozedDate
        statementId
        status
        subject
        supportingDocumentFileIds
        toSend
        hideLogo
        type
        _ttl
        unitId
        readId
        readers
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      creditNote
      creditNoteLabel
      customValues {
        name
        value
        __typename
      }
      disputedPostingIds
      disputes {
        id
        scope
        postingId
        postingLabel
        reason
        comment
        disputedOn
        openedAt
        openedById
        openDecisionId
        liftedAt
        liftedById
        liftCause
        liftDecisionId
        __typename
      }
      disputeStatus
      dueDate
      invoiceDate
      invoiceNumber
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      paid
      integrations {
        __typename
      }
      lastValidatedAt
      note
      postedDate
      purchaseOrderNumber
      receiptNumber
      reminderDates
      remittanceInformation
      reversedInvoiceId
      sentVersions {
        version
        sentAt
        invoiceNumber
        invoiceSenderId
        pdfFileId
        xmlFileId
        resetAt
        resetBy
        reason
        __typename
      }
      statementId
      statement {
        id
        attachSupportingDocuments
        closingStatement
        periodFrom
        periodTo
        selectedPocketKeys
        source
        status
        sentDate
        leaseId
        ownerId
        types
        viewType
        unitIds
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      status
      type
      unitId
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    chargeId
    charge {
      id
      status
      invoiceDate
      paymentDueDate
      archivedDate
      periodFrom
      periodTo
      totalAmount
      payableAmount
      source
      draftFromOcr
      accountingDocumentId
      paid
      settlement {
        bankCheck
        modeResolved
        modeSource
        __typename
      }
      remittanceInformation
      note
      creatorEmail
      createdById
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contractorId
      contractor {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedContractors {
        id
        confidence
        __typename
      }
      recipientId
      recipient {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      proposedRecipients {
        id
        confidence
        __typename
      }
      customValues {
        name
        value
        __typename
      }
      documentId
      sectionId
      document {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readId
      clientId
      openChargeClientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    transactionId
    transaction {
      id
      status
      snoozedUntil
      sequence
      statementDate
      operationDate
      customValues {
        name
        value
        __typename
      }
      remittanceInformationType
      remittanceInformation
      remittanceInformationRaw
      additionalInformation
      structuredCommunication
      bankTransactionCode
      proprietaryBankTransactionCode
      endToEndId
      mandateId
      creditorId
      purposeCode
      internalReference
      comment
      exclusionReason
      exclusionComment
      excludedAt
      excludedBy
      amount
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      counterpartName
      counterpartDisplayName
      counterpartAccountNumber
      origin
      sourceChannel
      nativeTransactionId
      fingerprint
      linkedSourceChannels
      proposedLeaseId
      proposedUnitId
      proposedContractorId
      proposedOwnerId
      proposedMatch
      proposedAllocation
      classification
      classificationConfidence
      classificationReason
      recurrence
      links {
        amount
        linkId
        linkType
        __typename
      }
      postings {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    accountLabelId
    accountLabel {
      id
      labels {
        language
        label
        __typename
      }
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      class
      customUsage
      customValues {
        name
        value
        __typename
      }
      disabled
      hoaFundId
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      topClass
      vatNonDeductiblePercentage
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseVariousOperationId
    leaseVariousOperation {
      id
      accountLabelIds
      amount
      billingMode
      contactId
      createdBy {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      dueDateDaysAfterPeriodStart
      endDate
      indexationBaseAmount
      indexationBaseIndexDate
      indexationFrozen
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      issueLeadDays
      label
      lastInvoiceDate
      leaseId
      lease {
        id
        balance
        canBeExtended
        communicationSettingsProfileId
        endDate
        includeRealEstateInLeaseContract
        invoiceSenderId
        inventoryOfFixturesExpert
        inventoryOfFixturesMethod
        inventoryOfFixturesType
        ipiNumber
        language
        lastDraftInvoiceDate
        lastIndexationProcessDate
        lastInvoiceDate
        legalCompetentAuthority
        name
        notes
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        purchaseOrderNumber
        realEstateAgency
        realEstateTax
        remittanceInformation
        remittanceInformationType
        signatureDate
        startDate
        nextIndexationMonth
        nextIndexation
        status
        subletting
        technicCommunicationSettingsProfileId
        totalInitialRentalPrice
        totalRentalPrice
        type
        vatRateRentId
        attachStatementSupportingDocuments
        bankAccountId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      leaseVariousOperationHistories {
        periodFrom
        periodTo
        amount
        __typename
      }
      operationType
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      periodNature
      reason
      separateInvoice
      startDate
      type
      unit {
        id
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        acquisitionValue
        advertisedMonthlyCharges
        advertisedRentalPrice
        cadastralIncome
        floor
        jointOwnershipId
        managementDate
        name
        notes
        predictedPrice
        propertyTax
        publishAddress
        surface
        type
        buildingId
        unitAdvertisementId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      unitId
      vatRateId
      vatRate {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      readers
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    statementId
    amountVatExcluded
    vatAmount
    vatRate {
      id
      country
      label
      value
      vatKind
      customValues {
        name
        value
        __typename
      }
      ownerId
      owner {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    vatRateId
    vatRateValue
    foreignId
    foreignType
    invoicePostingId
    reconciledAt
    decisionId
    status
    chargeOwnerRepartition
    chargeRepartitionMetric
    chargeRepartitionValue
    chargeSplitNumber
    chargeType
    tenantShare {
      basis
      mode
      percentage
      __typename
    }
    provisional
    flaggedAt
    carriedForward
    tenantLandings {
      amount
      amountVatExcluded
      days
      leaseId
      periodFrom
      periodTo
      statementId
      vatAmount
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateRecurringPaymentTemplate = /* GraphQL */ `subscription OnUpdateRecurringPaymentTemplate($filter: ModelSubscriptionRecurringPaymentTemplateFilterInput) {
  onUpdateRecurringPaymentTemplate(filter: $filter) {
    id
    amountVersions {
      amounts {
        amount
        fundId
        __typename
      }
      createdAt
      createdBy
      effectiveFrom
      note
      reserveFundAmount
      workingCapitalAmount
      __typename
    }
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryBankAccountId
    beneficiaryBankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    beneficiaryContactId
    beneficiaryContact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    createdBy
    endDate
    endedAt
    endedBy
    firstPeriodFrom
    funds {
      accountLabelId
      fundId
      remittanceInformation
      __typename
    }
    generationDay
    lastGeneratedPeriodFrom
    name
    periodicity
    remittanceInformation
    splitTransfers
    status
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateScheduleRule = /* GraphQL */ `subscription OnUpdateScheduleRule($filter: ModelSubscriptionScheduleRuleFilterInput) {
  onUpdateScheduleRule(filter: $filter) {
    id
    conditions {
      attribute {
        attributeName
        __typename
      }
      comparisonMode
      operator
      values
      valueKind
      __typename
    }
    conditionsOperator
    foreignKey
    foreignTableName
    name {
      language
      label
      __typename
    }
    order
    outcome {
      interval {
        __typename
      }
      type
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateSenderRule = /* GraphQL */ `subscription OnUpdateSenderRule($filter: ModelSubscriptionSenderRuleFilterInput) {
  onUpdateSenderRule(filter: $filter) {
    id
    senderId
    sender {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    kind
    scope {
      accountClass
      identifierKind
      identifierValue
      labelKey
      ownerId
      __typename
    }
    value {
      accountLabelId
      encodesInvoiceNumber
      paymentOnReceipt
      paymentTermDays
      privateExpense
      recoverabilityMode
      recoverabilityPercentage
      reminderFees
      roundingPrecision
      vatRateValues
      __typename
    }
    source
    confirmations
    updatedBy
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateSendingSource = /* GraphQL */ `subscription OnUpdateSendingSource($filter: ModelSubscriptionSendingSourceFilterInput) {
  onUpdateSendingSource(filter: $filter) {
    id
    createdById
    createdBy {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    dnsRecords {
      name
      type
      value
      __typename
    }
    emailAddress
    issuesEmail
    chargesEmail
    errorMessage
    name
    lastReminderDate
    status
    statusLastVerification
    verifiedType
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateSignatureDocument = /* GraphQL */ `subscription OnUpdateSignatureDocument($filter: ModelSubscriptionSignatureDocumentFilterInput) {
  onUpdateSignatureDocument(filter: $filter) {
    id
    additionalMessage
    automaticRemindersDisabled
    communicationBody
    expirationDate
    fileIds
    foreignKey
    foreignTableName
    sentAt
    signatureMethods
    signatureResults {
      openedDate
      signedDate
      signed
      signatureLink
      rejectReason
      lastSignInviteSentDate
      reminderDates
      trackingProvider
      trackingCode
      contactId
      __typename
    }
    status
    externalStatus
    type
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateSubscriptionUsageHistory = /* GraphQL */ `subscription OnUpdateSubscriptionUsageHistory($filter: ModelSubscriptionSubscriptionUsageHistoryFilterInput) {
  onUpdateSubscriptionUsageHistory(filter: $filter) {
    id
    clientId
    creditUsageDetail {
      numberUsed
      creditsAccount
      creditOperationType
      __typename
    }
    customerCreatorId
    requestId
    applicationInvoiceId
    storageUsageDetail {
      numberUsed
      __typename
    }
    type
    unitsUsageDetail {
      unitsUsage {
        numberUsed
        unitId
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      proRataUnits {
        unitId
        numberOfDays
        lastKnownLeasePrice
        advertisedRentalPrice
        type
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateTag = /* GraphQL */ `subscription OnUpdateTag($filter: ModelSubscriptionTagFilterInput) {
  onUpdateTag(filter: $filter) {
    id
    color
    foreignTableName
    labels {
      language
      label
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateTechnic = /* GraphQL */ `subscription OnUpdateTechnic($filter: ModelSubscriptionTechnicFilterInput) {
  onUpdateTechnic(filter: $filter) {
    id
    type
    technicLibraryId
    technicLibrary {
      id
      certificateValidity {
        nonCompliant
        overlapping
        riskLevel
        __typename
      }
      communicationSettingsProfileId
      criticality
      customFields {
        nextToken
        startedAt
        __typename
      }
      descriptions {
        language
        label
        __typename
      }
      isDefault
      issuingAuthority
      linkedCertificateIds
      locationScope
      maintenanceSchemas {
        id
        criticality
        deadline
        maintenanceType
        notificationsEnabled
        notificationType
        proofType
        recurrence
        responsibleParty
        triggerType
        __typename
      }
      names {
        language
        label
        __typename
      }
      status
      tagIds
      technicLibraryFormat
      type
      utilityTypes
      validity {
        value
        validityUnit
        __typename
      }
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    technicName
    lastControlDate
    status
    contractNumber
    communicationSettingsProfileId
    maintenanceHistory {
      date
      contactId
      customValues {
        name
        value
        __typename
      }
      fileId
      id
      maintenanceSchemaId
      __typename
    }
    utilityType
    utilityEanCode
    utilityMeterNumber
    utilityDistributorId
    utilityDistributor {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    utilityHistory {
      date
      reason
      reading
      secondReading
      __typename
    }
    files {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    leaseId
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    customValues {
      name
      value
      __typename
    }
    originalTechnicId
    replacedTechnicId
    certificateIds
    readers
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateTechnicLibrary = /* GraphQL */ `subscription OnUpdateTechnicLibrary($filter: ModelSubscriptionTechnicLibraryFilterInput) {
  onUpdateTechnicLibrary(filter: $filter) {
    id
    certificateValidity {
      gracePeriod {
        value
        validityUnit
        __typename
      }
      nonCompliant
      overlapping
      riskLevel
      __typename
    }
    communicationSettingsProfileId
    criticality
    customFields {
      items {
        id
        fieldName
        fieldType
        foreignKey
        foreignTableName
        order
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    descriptions {
      language
      label
      __typename
    }
    isDefault
    issuingAuthority
    linkedCertificateIds
    locationScope
    maintenanceSchemas {
      id
      criticality
      deadline
      descriptions {
        language
        label
        __typename
      }
      interval {
        value
        validityUnit
        __typename
      }
      maintenanceType
      names {
        language
        label
        __typename
      }
      notificationsEnabled
      notificationType
      proofType
      proofTypeName {
        language
        label
        __typename
      }
      recurrence
      responsibleParty
      triggerType
      __typename
    }
    names {
      language
      label
      __typename
    }
    status
    tagIds
    technicLibraryFormat
    type
    utilityTypes
    validity {
      value
      validityUnit
      __typename
    }
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateTicket = /* GraphQL */ `subscription OnUpdateTicket($filter: ModelSubscriptionTicketFilterInput) {
  onUpdateTicket(filter: $filter) {
    id
    assignedAt
    assignedTo {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    assignedToId
    attachment {
      items {
        id
        bucket
        categoryId
        foreignKey
        foreignTableName
        key
        mimeType
        region
        size
        readers
        readId
        clientId
        _ttl
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    buildingId
    closedAt
    contact {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    contactId
    content
    conversations {
      items {
        id
        assignedAt
        assignedToId
        buildingId
        closedAt
        contactId
        content
        emailMessageId
        emailReferences
        parentId
        plannedAt
        referenceCode
        sourceType
        status
        subject
        unitId
        unread
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    emailMessageId
    emailReferences
    parentId
    plannedAt
    referenceCode
    sourceType
    status
    subject
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    unread
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateTransaction = /* GraphQL */ `subscription OnUpdateTransaction($filter: ModelSubscriptionTransactionFilterInput) {
  onUpdateTransaction(filter: $filter) {
    id
    status
    snoozedUntil
    sequence
    statementDate
    operationDate
    customValues {
      name
      value
      __typename
    }
    remittanceInformationType
    remittanceInformation
    remittanceInformationRaw
    additionalInformation
    structuredCommunication
    bankTransactionCode
    proprietaryBankTransactionCode
    endToEndId
    mandateId
    creditorId
    purposeCode
    internalReference
    comment
    exclusionReason
    exclusionComment
    excludedAt
    excludedBy
    amount
    bankAccountId
    bankAccount {
      id
      contactId
      contact {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contactIds
      buildingIds
      number
      bicNumber
      bankName
      holderName
      label
      customValues {
        name
        value
        __typename
      }
      disabled
      integrations
      matchingRule
      initiationChannel
      retainedBalanceThreshold
      balance
      balanceDate
      type
      ibanStatus
      ibanVerifiedAt
      ibanVerifiedBy
      ibanVerifiedNumber
      ibanVerifiedSourceDocumentId
      ibanRole
      ibanRoleLabel
      isDefault
      note
      paymentRunPriorityOrderIds
      paymentRunPriorityUpdatedAt
      paymentRunPriorityUpdatedBy
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    counterpartName
    counterpartDisplayName
    counterpartAccountNumber
    origin
    sourceChannel
    nativeTransactionId
    fingerprint
    linkedSourceChannels
    proposedLeaseId
    proposedUnitId
    proposedContractorId
    proposedOwnerId
    proposedMatch
    proposedAllocation
    classification
    classificationConfidence
    classificationReason
    recurrence
    links {
      amount
      linkId
      linkType
      __typename
    }
    postings {
      items {
        id
        class
        customLabel
        topClass
        type
        totalAmount
        periodFrom
        periodTo
        buildingId
        unitId
        invoiceId
        chargeId
        transactionId
        leaseId
        bankAccountId
        accountLabelId
        contactId
        leaseVariousOperationId
        statementId
        amountVatExcluded
        vatAmount
        vatRateId
        vatRateValue
        foreignId
        foreignType
        invoicePostingId
        reconciledAt
        decisionId
        status
        chargeOwnerRepartition
        chargeRepartitionMetric
        chargeRepartitionValue
        chargeSplitNumber
        chargeType
        provisional
        flaggedAt
        carriedForward
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateUnit = /* GraphQL */ `subscription OnUpdateUnit($filter: ModelSubscriptionUnitFilterInput) {
  onUpdateUnit(filter: $filter) {
    id
    acquisitionAdditionalCostsValue
    acquisitionAdvertisedValue
    acquisitionValue
    advertisedMonthlyCharges
    advertisedRentalPrice
    cadastralIncome
    customValues {
      name
      value
      __typename
    }
    floor
    jointOwnershipId
    managementDate
    name
    notes
    predictedPrice
    propertyTax
    publishAddress
    surface
    type
    buildingId
    building {
      id
      name
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      acquisitionValue
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      amountOfFacades
      amountOfFloors
      amountOfHousings
      buildingState
      cadastralIncome
      constructionYear
      customValues {
        name
        value
        __typename
      }
      janitor
      jointOwnershipId
      notes
      owners {
        nextToken
        startedAt
        __typename
      }
      propertyTax
      residenceName
      buildingSiteId
      buildingSite {
        id
        name
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      readers
      teams
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    owners {
      items {
        id
        disabled
        ownerId
        periodFrom
        periodTo
        stake
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    leases {
      items {
        id
        allowChargeAdjustment
        authorizeProfessionalActivity
        chargesIndexation
        endDate
        furnishedRental
        furnishedRentalInsuranceByTenant
        furnishedRentalRentalPricePercentage
        initialRentalPrice
        indexation
        advancedIndexation
        indexType
        baseYear
        baseIndexType
        baseIndexDate
        nextIndexationMonth
        nextIndexation
        leaseId
        mainUnit
        rentalPrice
        signatureDate
        startDate
        unitId
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    events {
      items {
        id
        unitId
        type
        startDate
        endDate
        totalCost
        note
        writers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    unitAdvertisementId
    unitInventories {
      items {
        id
        privateBatthRoom
        deletedAt
        kitchenEquipment
        roomName
        roomType
        surface
        showSurface
        unitId
        inside
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      nextToken
      startedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateUnitEvent = /* GraphQL */ `subscription OnUpdateUnitEvent($filter: ModelSubscriptionUnitEventFilterInput) {
  onUpdateUnitEvent(filter: $filter) {
    id
    unitId
    type
    startDate
    endDate
    totalCost
    note
    writers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateUnitInventory = /* GraphQL */ `subscription OnUpdateUnitInventory($filter: ModelSubscriptionUnitInventoryFilterInput) {
  onUpdateUnitInventory(filter: $filter) {
    id
    privateBatthRoom
    deletedAt
    kitchenEquipment
    roomName
    roomType
    surface
    showSurface
    unitId
    inside
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateUnitLease = /* GraphQL */ `subscription OnUpdateUnitLease($filter: ModelSubscriptionUnitLeaseFilterInput) {
  onUpdateUnitLease(filter: $filter) {
    id
    allowChargeAdjustment
    authorizeProfessionalActivity
    chargesIndexation
    endDate
    furnishedRental
    furnishedRentalInsuranceByTenant
    furnishedRentalRentalPricePercentage
    initialRentalPrice
    indexation
    advancedIndexation
    indexType
    baseYear
    baseIndexType
    baseIndexDate
    nextIndexationMonth
    nextIndexation
    leaseId
    mainUnit
    rentalPrice
    signatureDate
    startDate
    unitId
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    lease {
      id
      advancedChargesInvoices {
        communicationSettingsProfileId
        invoiceSenderId
        lastDraftInvoiceDate
        lastInvoiceDate
        paymentFrequency
        paymentInvoicePeriod
        paymentInvoicePeriodCustomDay
        remittanceInformation
        remittanceInformationType
        bankAccountId
        __typename
      }
      balance
      canBeExtended
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      endDate
      includeRealEstateInLeaseContract
      invoiceSenderId
      invoiceSender {
        id
        firstName
        lastName
        companyName
        commercialName
        communicationSettingsProfileId
        businessNumber
        types
        vat
        email
        birthDate
        birthPlace
        nationalRegister
        ipiNumber
        insuranceCompany
        insuranceContractNumber
        judicialDistrict
        civility
        addressId
        language
        notes
        profileType
        paymentTermDays
        defaultBankAccountId
        supplierPaymentMode
        agencyRateDisabled
        attachStatementSupportingDocuments
        status
        sendInvitation
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      inventoryOfFixturesExpert
      inventoryOfFixturesMethod
      inventoryOfFixturesType
      ipiNumber
      language
      lastDraftInvoiceDate
      lastIndexationProcessDate
      lastInvoiceDate
      legalCompetentAuthority
      name
      notes
      paymentFrequency
      paymentInvoicePeriod
      paymentInvoicePeriodCustomDay
      paymentOption {
        enabled
        mandateStatus
        mandateActivatedAt
        customerId
        paymentMethodId
        qrType
        __typename
      }
      purchaseOrderNumber
      realEstateAgency
      realEstateTax
      remittanceInformation
      remittanceInformationType
      rentalGuaranty {
        amount
        blockedAmount
        releasedAmount
        type
        financialInstitution
        __typename
      }
      signatureDate
      startDate
      nextIndexationMonth
      nextIndexation
      status
      subletting
      technicCommunicationSettingsProfileId
      totalInitialRentalPrice
      totalRentalPrice
      type
      vatRateRentId
      vatRateRent {
        id
        country
        label
        value
        vatKind
        ownerId
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      additionalClauses {
        nextToken
        startedAt
        __typename
      }
      attachStatementSupportingDocuments
      bankAccountId
      bankAccount {
        id
        contactId
        contactIds
        buildingIds
        number
        bicNumber
        bankName
        holderName
        label
        disabled
        integrations
        matchingRule
        initiationChannel
        retainedBalanceThreshold
        balance
        balanceDate
        type
        ibanStatus
        ibanVerifiedAt
        ibanVerifiedBy
        ibanVerifiedNumber
        ibanVerifiedSourceDocumentId
        ibanRole
        ibanRoleLabel
        isDefault
        note
        paymentRunPriorityOrderIds
        paymentRunPriorityUpdatedAt
        paymentRunPriorityUpdatedBy
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      contacts {
        nextToken
        startedAt
        __typename
      }
      files {
        nextToken
        startedAt
        __typename
      }
      leaseActionHistories {
        nextToken
        startedAt
        __typename
      }
      leasePriceHistories {
        nextToken
        startedAt
        __typename
      }
      signatureDocuments {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      variousOperations {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;

export const onUpdateUnitOwner = /* GraphQL */ `subscription OnUpdateUnitOwner($filter: ModelSubscriptionUnitOwnerFilterInput) {
  onUpdateUnitOwner(filter: $filter) {
    id
    disabled
    owner {
      id
      firstName
      lastName
      companyName
      commercialName
      communicationSettingsProfileId
      customValues {
        name
        value
        __typename
      }
      businessNumber
      types
      vat
      emails {
        address
        isPrimary
        label
        __typename
      }
      email
      birthDate
      birthPlace
      nationalRegister
      ipiNumber
      insuranceCompany
      insuranceContractNumber
      judicialDistrict
      civility
      addressId
      address {
        id
        status
        street
        number
        box
        postalCode
        city
        region
        country
        latitude
        longitude
        readers
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      phoneNumbers {
        countryCode
        isPrimary
        label
        number
        __typename
      }
      language
      notes
      profileType
      jointOwners {
        contactId
        contactPerson
        __typename
      }
      hoaFunds {
        archivedAt
        id
        kind
        name
        __typename
      }
      paymentTermDays
      acpSyndicEras {
        syndicContactId
        validFrom
        validTo
        __typename
      }
      acpSyndicHistory {
        changedAt
        changedBy
        previousSyndicContactId
        previousValidFrom
        syndicContactId
        validFrom
        __typename
      }
      defaultBankAccountId
      supplierPaymentMode
      supplierPaymentModeExceptions {
        confirmedAt
        confirmedBy
        mode
        ownerId
        __typename
      }
      supplierPaymentModeHistory {
        changedAt
        changedBy
        mode
        ownerId
        previousMode
        __typename
      }
      agencyRateDisabled
      attachStatementSupportingDocuments
      status
      leases {
        nextToken
        startedAt
        __typename
      }
      buildings {
        nextToken
        startedAt
        __typename
      }
      units {
        nextToken
        startedAt
        __typename
      }
      sendInvitation
      peppolProperties {
        isRegistered
        mustSend
        __typename
      }
      integrations {
        __typename
      }
      readers
      readId
      clientId
      sourceEntityRelations {
        nextToken
        startedAt
        __typename
      }
      foreignEntityRelations {
        nextToken
        startedAt
        __typename
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    ownerId
    periodFrom
    periodTo
    stake
    unit {
      id
      acquisitionAdditionalCostsValue
      acquisitionAdvertisedValue
      acquisitionValue
      advertisedMonthlyCharges
      advertisedRentalPrice
      cadastralIncome
      customValues {
        name
        value
        __typename
      }
      floor
      jointOwnershipId
      managementDate
      name
      notes
      predictedPrice
      propertyTax
      publishAddress
      surface
      type
      buildingId
      building {
        id
        name
        addressId
        acquisitionValue
        acquisitionAdditionalCostsValue
        acquisitionAdvertisedValue
        amountOfFacades
        amountOfFloors
        amountOfHousings
        buildingState
        cadastralIncome
        constructionYear
        janitor
        jointOwnershipId
        notes
        propertyTax
        residenceName
        buildingSiteId
        readers
        teams
        readId
        clientId
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
        __typename
      }
      owners {
        nextToken
        startedAt
        __typename
      }
      leases {
        nextToken
        startedAt
        __typename
      }
      events {
        nextToken
        startedAt
        __typename
      }
      unitAdvertisementId
      unitInventories {
        nextToken
        startedAt
        __typename
      }
      readers
      readId
      clientId
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
      __typename
    }
    unitId
    readers
    readId
    clientId
    createdAt
    updatedAt
    _version
    _deleted
    _lastChangedAt
    __typename
  }
}
`;
